<template>
  <div class="inner-content r-center">
    <div class="clearfix m-t-30">
      <div class="f-1">{{postDetail.title}}</div>
      <div class="f-2 m-t-20">时间：{{postDetail.createTime.substring(0,10)}}
      &nbsp;&nbsp;&nbsp;编辑：{{postDetail.editor}}</div>
      <div class="m-t-20">
        <span class="rectangle-theme f-3">{{postDetail.themeTitle}}</span>
      </div>
    </div>
    <div>
      <div v-if="postDetail.type === 1" class="m-b-33">
        <div v-for="pc in postDetail.content">
          <div class="f-1 m-t-35" v-if="pc.title != ''">{{pc.title}}</div>
          <div class="r-left content-area f-4 m-t-30">{{pc.text}}</div>
          <img class="img-n-detail-div m-t-20" :src="pc.image"/>
        </div>
      </div>
      <div v-if="postDetail.type === 2" class="m-b-33">
        <div v-for="pc in postDetail.content">
          <div class="f-1 m-t-35" v-if="pc.title != ''">{{pc.title}}</div>
          <div class="r-left content-area f-4 m-t-30">{{pc.text}}</div>
          <img class="img-n-detail-div m-t-20" :src="pc.image"/>
        </div>
      </div>
      <div v-if="postDetail.type === 3" class="m-b-33">

      </div>
      <div v-if="postDetail.type === 4" class="m-b-33">
        {{/** 视频 */}}
        <div class="r-left content-area f-4 m-t-30">{{postDetail.content.text}}</div>
        <div class="m-t-20">
            <video-player :options="videoOptions"></video-player>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import toastr from 'mini-toastr';
  import { videoPlayer } from 'vue-video-player';
  import service from '../service/apiHelper';

  export default {
    name: 'NewsDetail',
    data() {
      return {
        url: {},
        posterUuid: '',
        postDetail: {
          content: {
            title: '',
            text: '',
          },
        },
      };
    },
    components: {
      videoPlayer,
    },
    created() {
      this.posterUuid = this.$route.params.id || '4b1c83a5-262f-478c-8b2f-f02feb597d6e';
      service.homePosterDetail(this.posterUuid).then((resp) => {
        this.postDetail = resp.data;
      }, (resp) => {
        toastr.error(resp, '加载资讯详情错误');
      });
    },
    computed: {
      videoOptions() {
        this.postDetail.content.url = JSON.stringify(this.postDetail.content.url);
        this.url = JSON.parse(this.postDetail.content.url);
        const txt = this.url;
        return {
          sources: [{
            src: txt,
          }],
        };
      },
    },
  };
</script>
<style scoped>
  .r-center {
    text-align: center;
  }

  .r-left {
    text-align: left;
  }

  .m-t-30 {
    margin-top: 30px;
  }

  .m-t-35 {
    margin-top: 35px;
  }

  .m-t-20 {
    margin-top: 20px;
  }

  .m-t-89 {
    margin-top: 89px;
  }

  .m-b-33 {
    margin-bottom: 44px;
  }

  .f-1 {
    font-size: 20px;
    color: #252525;
    font-weight: 600;
    line-height: 28px;
  }

  .f-2 {
    font-size: 14px;
    color: #787878;
    font-weight: 300;
    line-height: 20px;
  }

  .f-3 {
    font-size: 14px;
    color: #df3a4e;
    padding: 4px 22px;
  }

  .f-4 {
    font-size: 15px;
    /*line-height: 22px;*/
    line-height: 1.83;
    color: #525252;
    font-weight: 300;
  }

  .rectangle-theme {
    width: 99.8px;
    height: 28px;
    border-radius: 1px;
    border: solid 1px #df3a4e;
    text-align: center;
    line-height: 28px;
  }

  .content-area {
    width: 100%;
  }

  .clamp {
    word-break:break-all;
    display:-webkit-box;
    -webkit-line-clamp:3;
    -webkit-box-orient:vertical;
    overflow:hidden;
  }

  .img-n-detail-div {
    width: 85%;
    height: auto;
  }

  /*img-style{*/
    /*background-position: center;*/
    /*background-repeat: no-repeat;*/
    /*background-size: cover;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// NewsDetail.vue?3bcd2574